import React, { useRef } from 'react';

import { Box, Button, Typography } from '@mui/material';
import { QRCodeCanvas } from 'qrcode.react';

type QRCodeProps = {
  link: string;
};

export default function QRCodeDownload({ link }: QRCodeProps): JSX.Element {
  const canvasRef = useRef<HTMLCanvasElement | null>(null);

  const handleDownload = () => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const pngUrl = canvas.toDataURL('image/png');
    const downloadLink = document.createElement('a');
    downloadLink.href = pngUrl;
    downloadLink.download = 'qrcode.png';
    downloadLink.click();
  };

  return (
    <Box display="flex" flexDirection="row" alignItems="center" gap={2}>
      <Typography variant="h6">QR Code:</Typography>
      <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
        <Box
          sx={{
            width: 256,
            height: 256,
            '& canvas': {
              width: '100% !important',
              height: '100% !important',
            },
          }}
        >
          <QRCodeCanvas
            value={link.startsWith('http') ? link : `https://${link}`}
            size={1024}
            includeMargin
            ref={canvasRef}
          />
        </Box>
        <Button variant="contained" onClick={handleDownload}>
          Baixar QR Code
        </Button>
      </Box>
    </Box>
  );
}
